// Autofocus is intentional
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useCallback, useEffect, useRef, useState, } from "../../__compat__/react/main.entry.mjs.mjs";
import { useOverlayTrigger, useOverlayPosition, } from "../../__compat__/@react-aria/overlays/main.entry.mjs.mjs";
import { PopoverContext, containerPadding } from "./context.mjs.mjs";
const PopoverTriggerBase = ({ children, popoverProps }) => {
    return (React.createElement(PopoverContext.Provider, { value: { ...popoverProps } }, children));
};
export const PopoverTrigger = ({ autoFocus = false, children, placement = 'bottom', tip = false, targetRef, keepContentHeight, onClose = () => { }, onOpen, controlledClose, }) => {
    var _a, _b;
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    const overlayRef = useRef(null);
    const { triggerProps, overlayProps } = useOverlayTrigger({ type: 'dialog' }, {
        isOpen: open,
        open: () => setOpen(true),
        close: () => setOpen(false),
        toggle: () => setOpen(!open),
    }, triggerRef);
    const isHorizontalPlacement = !placement.includes('top') && !placement.includes('bottom');
    const boundaryElement = (isHorizontalPlacement &&
        ((_b = (_a = (targetRef || triggerRef)) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.offsetParent)) ||
        undefined;
    const { overlayProps: positionProps, placement: overlayPlacement, arrowProps: tipProps, } = useOverlayPosition({
        targetRef: targetRef || triggerRef,
        overlayRef,
        placement,
        offset: 0,
        isOpen: open,
        containerPadding,
        boundaryElement,
    });
    const handleClick = useCallback(() => {
        setOpen(!open);
        if (!open && onOpen) {
            onOpen();
        }
        if (open) {
            onClose();
        }
    }, [onClose, onOpen, open]);
    const handleClose = useCallback(() => {
        onClose();
        setOpen(false);
    }, [onClose]);
    const triggerPropsWithRef = {
        ...triggerProps,
        onClick: handleClick,
        ref: triggerRef,
    };
    useEffect(() => {
        if (typeof controlledClose === 'undefined') {
            return;
        }
        if (!controlledClose) {
            setOpen(false);
            onClose();
        }
    }, [controlledClose, onClose, onOpen]);
    return (React.createElement(PopoverTriggerBase, { popoverProps: {
            autoFocus,
            containerPadding,
            open,
            onClose: handleClose,
            ...overlayProps,
            ...positionProps,
            tipProps: { ...tipProps, 'aria-hidden': true },
            tip,
            placement: overlayPlacement,
            ref: overlayRef,
            triggerRef,
            keepContentHeight,
        } }, children(triggerPropsWithRef, handleClose)));
};
//# sourceMappingURL=PopoverTrigger.mjs.mjs.map